// extracted by mini-css-extract-plugin
module.exports = {"loyalty":"_--C_j_0u00Jg","loyalty__gainedMiles":"_2bophv0njdQ1","loyalty__awardedInfo":"_3WIq37yZwFZS"};